import React, { useState } from "react";
import styles from "./InfoTip.module.css";
import TipProvider from "./components/TipProvider/TipProvider";
import EventableArea from "./components/TipProvider/EventableArea";
import MessageTip from "./components/MessageTip/MessageTip";

type InfoTipProps = {
	children: React.ReactNode;
	image: React.ReactNode;
	style?: React.CSSProperties;
};

export const InfoTip: React.FC<InfoTipProps> = ({ children, image, style }) => {
	const [loaderAnimate, setLoaderAnimate] = useState(false);

	return (
		<TipProvider setAnimation={setLoaderAnimate}>
			<EventableArea>{image}</EventableArea>
			<MessageTip>
				<div
					className={`${styles.tipBackground} ${
						loaderAnimate ? styles.loaderAnimate : ""
					}`}
					style={style}
				>
					{children}
				</div>
			</MessageTip>
		</TipProvider>
	);
};
